import { useCallback, useEffect, useState } from "react"

import { Icon } from "@/components/icon/Icon"

const SIZE = 48
const STROKE = 2
const RADIUS = (SIZE - STROKE) / 2
const CIRCUMFERENCE = 2 * Math.PI * RADIUS

export function ScrollToTop() {
	const [progress, setProgress] = useState(0)
	const [visible, setVisible] = useState(false)

	useEffect(() => {
		function onScroll() {
			const scrollTop = window.scrollY
			const docHeight = document.documentElement.scrollHeight - window.innerHeight
			const pct = docHeight > 0 ? Math.min(scrollTop / docHeight, 1) : 0
			setProgress(pct)
			setVisible(scrollTop > 300)
		}
		window.addEventListener("scroll", onScroll, { passive: true })
		onScroll()
		return () => window.removeEventListener("scroll", onScroll)
	}, [])

	const scrollToTop = useCallback(() => {
		window.scrollTo({ top: 0, behavior: "smooth" })
	}, [])

	const dashOffset = CIRCUMFERENCE * (1 - progress)

	return (
		<button
			type="button"
			aria-label="Scroll to top"
			onClick={scrollToTop}
			className={`fixed right-6 bottom-6 z-50 flex cursor-pointer items-center justify-center rounded-full shadow-lg transition-all duration-300 ease-out ${
				visible
					? "translate-y-0 opacity-100"
					: "pointer-events-none translate-y-4 opacity-0"
			}`}
			style={{ width: SIZE, height: SIZE }}
		>
			<svg
				width={SIZE}
				height={SIZE}
				className="absolute inset-0"
			>
				<circle
					cx={SIZE / 2}
					cy={SIZE / 2}
					r={RADIUS}
					fill="var(--color-surface-container-lowest)"
					stroke="var(--color-hairline)"
					strokeWidth={STROKE}
				/>
				<circle
					cx={SIZE / 2}
					cy={SIZE / 2}
					r={RADIUS}
					fill="none"
					stroke="var(--color-primary)"
					strokeWidth={STROKE}
					strokeLinecap="round"
					strokeDasharray={CIRCUMFERENCE}
					strokeDashoffset={dashOffset}
					className="transition-[stroke-dashoffset] duration-100 ease-out"
					style={{ transform: "rotate(-90deg)", transformOrigin: "center" }}
				/>
			</svg>
			<Icon
				name="arrow_upward"
				size={20}
				className="text-primary relative"
			/>
		</button>
	)
}
